(function () {
  'use strict';

  /* @ngdoc object
   * @name dashboard.stats
   * @description
   *
   */
  angular
    .module('dashboard.stats', [
      'ui.router'
    ]);
}());
